module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "p1h5"
    }
  }, [_c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "id": "img13",
      "src": "images/img13.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Typical army discharge of the Indian wars period. This one is to Corporal Patrick Prendergast, Company A, Second Infantry, at Fort Omaha, Nebraska, 1893. Prendergast’s unit joined the army command at Pine Ridge Agency in 1890 and served against the Sioux Indians, but he was unsuccessful in seeking a pension for that duty. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Editor’s Collection")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2e68a90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IndianWarVeterans_p15.vue
// module id = 144
// module chunks = 0